import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const UserSignInContext = React.createContext(undefined);
const UserSignInDispatchContext = React.createContext(undefined);
const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_AT_SIGN_IN':
            return Object.assign(Object.assign({}, state), { signedInCallBackResult: action.payload });
        default:
            throw new Error('Unhandled action type');
    }
};
const UserSignInProvider = ({ children }) => {
    const initialState = { signedInCallBackResult: false };
    const [state, dispatch] = React.useReducer(reducer, initialState);
    return (_jsx(UserSignInContext.Provider, { value: state, children: _jsx(UserSignInDispatchContext.Provider, { value: dispatch, children: children }) }));
};
const useUserSignInState = () => {
    const context = React.useContext(UserSignInContext);
    if (context === undefined) {
        throw new Error('useUserSignInState must be used within a UserSignInProvider');
    }
    return context;
};
const useUserSignInDispatch = () => {
    const context = React.useContext(UserSignInDispatchContext);
    if (context === undefined) {
        throw new Error('useUserSignInDispatch must be used within a UserSignInProvider');
    }
    return context;
};
export { UserSignInProvider as UserSignInProvider, useUserSignInState as useUserSignInState, useUserSignInDispatch as useUserSignInDispatch, };
